import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, throwError } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { AuthService, NotificationService } from '../../../core/services';

@Component({
  selector: 'app-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
})
export class ForgotPassword implements OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  isLoading = false;
  submitted = false;
  submittedEmail = '';

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private notificationService: NotificationService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const email = this.form.value.email;

    this.isLoading = true;
    this.authService.requestPasswordReset(email)
      .pipe(
        takeUntil(this._destroy$),
        catchError(error => {
          const message = error?.status === 429
            ? 'Too many attempts. Please wait a few minutes and try again.'
            : 'Could not send the reset email. Please try again later.';
          this.notificationService.error(message);
          return throwError(() => error);
        }),
        tap(() => {
          // Deliberately non-enumerating server-side show the same confirmation regardless
          // of whether the address is actually registered.
          this.submittedEmail = email;
          this.submitted = true;
        }),
        finalize(() => { this.isLoading = false; }),
      ).subscribe();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
